import { Injectable } from '@angular/core';
import DatawizAuth from '@datawizio/auth-js';
import { Tokens } from './session.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	static authService = new DatawizAuth(window.CONFIG.auth);

	private _refreshTokenInProgress: boolean = false;
	private _refreshTokenCallbacks: Array<Function> = [];

	static async auth(): Promise<boolean> {
		const tokens = await this.authService.init();
		if (!tokens) return false;

		this.setTokens(tokens);
		return true;
	}

	private static setTokens(tokens: Tokens): void {
		window.localStorage.setItem('refreshToken', tokens.refreshToken);
		window.localStorage.setItem('token', tokens.accessToken);
	}

	constructor() {}

	logout(): void {
		window.CRISP_TOKEN_ID = '';
		window.$crisp.push(['do', 'session:reset']);
		AuthService.authService.logout().then();
	}

	async refreshToken(): Promise<any> {
		if (this._refreshTokenInProgress) {
			return new Promise((resolve) => {
				this._refreshTokenCallbacks.push(resolve);
			});
		}
		this._refreshTokenInProgress = true;
		this._refreshTokenCallbacks = [];
		return AuthService.authService
			.refreshToken()
			.then((res) => {
				const callbacks = this._refreshTokenCallbacks.concat();
				this._refreshTokenInProgress = false;
				this._refreshTokenCallbacks = [];
				AuthService.setTokens(res);
				callbacks.forEach((callback) => {
					callback(res);
				});

				return res;
			})
			.catch(() => {});
	}
}
